export default "__VITE_ASSET__BVkLYwrE__"